import { Input, InputField, InputIcon, InputSlot, Pressable } from "wealthmode-frontend/gluestack/ui"
import { SearchIcon, XIcon } from "wealthmode-frontend/icons"

import type { DataTableSearch } from "@/components/DataTable"

export function TableSearchInput({
  mode,
  value,
  onChangeText,
}: {
  mode: DataTableSearch["mode"]
  value: string
  onChangeText: (text: string) => void
}) {
  const placeholder = mode === "remote" ? "search all data" : "filter current page"

  const clearInput = () => {
    onChangeText("")
  }

  return (
    <Input
      variant="rounded"
      className="border border-border-medium bg-background-primary w-full min-w-0 outline-none focus-within:ring-2 focus-within:ring-border-focused focus-within:border-transparent data-[focus=true]:web:ring-0"
      size="sm"
    >
      <InputSlot>
        <InputIcon
          as={SearchIcon}
          className="ml-2"
          size="sm"
        />
      </InputSlot>
      <InputField
        placeholder={placeholder}
        value={value}
        onChangeText={onChangeText}
        className="min-w-0 flex-1 text-sm !border-0 !bg-transparent shadow-none outline-none focus:outline-none focus:!ring-0 rounded-none px-2 py-0"
      />
      {value.length > 0 && (
        <InputSlot className="mr-2">
          <Pressable onPress={clearInput}>
            <InputIcon
              as={XIcon}
              size="sm"
            />
          </Pressable>
        </InputSlot>
      )}
    </Input>
  )
}
